import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
import { ConfigurationStore } from '../state-management/stores/configuration.store';
import { ECPStore } from '../state-management/stores/ecp.store';
import { authCodeFlowConfig } from './zeiss-id-config';

export function initOEFactory(
	oAuthService: OAuthService,
	ecpStore: InstanceType<typeof ECPStore>,
	configStore: InstanceType<typeof ConfigurationStore>,
): () => Promise<void> {
	return async () => {
		oAuthSetup(oAuthService);
		const userIsLoggedIn = await oAuthLogin(oAuthService);

		if (userIsLoggedIn) {
			await ecpStore.fetchSoldToStores();
			await ecpStore.fetchSelectedSoldToStore();
			if (ecpStore.selectedSoldToStore()) {
				await configStore.fetchCountrySpecificSettings();
			}
		} else {
			console.error('User is not logged in');
		}
	};
}

function oAuthLogin(oAuthService: OAuthService) {
	return oAuthService
		.loadDiscoveryDocument(environment.auth.discoveryDocument)
		.then(() => {
			return oAuthService.tryLogin();
		})
		.then(() => {
			return oAuthService.hasValidAccessToken();
		});
}

function oAuthSetup(oAuthService: OAuthService) {
	oAuthService.configure(authCodeFlowConfig);
	oAuthService.setupAutomaticSilentRefresh();
}
